



















































































import {Component, Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import {ProductRecommendedCodeInfoDialogRequest, WhoddListInfo} from '@/model/CommonModel';
import CommonButton from '@/components/button/CommonButton.vue';
import AiCodingApi from '@/api/AiCodingApi';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';

@Component({
  components: {CommonPaginatedTable, CommonButton, CommonPromptDialog},
  mixins: [DialogEventsMixin, DefaultComponentMixin]
})
export default class ProductRecommendedCodeInfoDialog extends Mixins(DefaultComponentMixin, DialogEventsMixin) {
  private dialogVisible: boolean = false;
  private whoddCode: string = '';
  private onMore: any;
  private whoddInfo: WhoddListInfo = {
    medicinalProductId: '',
    drugCode: '',
    drugName: '',
    nameSpecifier: '',
    ingredients: '',
    generic: '',
    preferred: '',
    country: '',
    mah: '',
    pharmForm: '',
    strength: '',
    preferredName: '',
    selAtcCode: '',
    selAtcName: '',
    atcCode: '',
    atcName: '',
    bgColor: '',
  };

  get isVisible() {
    return this.dialogVisible;
  }

  get isLoading() {
    return this.loading;
  }

  get getData() {
    return (data: string) => data ?? '-';
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showProductRecommendedCodeInfoDialog', (params: ProductRecommendedCodeInfoDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideProductRecommendedCodeInfoDialog', () => this.onConfirm());
  }

  public show(params: ProductRecommendedCodeInfoDialogRequest) {
    this.onMore = () => params.onMore(this);
    if (this.whoddCode === params.whoddCode) {
      return;
    }

    this.dialogVisible = true;
    this.loading = true;

    AiCodingApi.retrieveWhoddCode(params.whoddCode)
        .then((res) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }
          this.whoddInfo = res.data;
        })
        .catch((errMsg) => this.afterRequestFail(errMsg))
        .finally(() => {
          this.loading = false;
        });
  }

  public onConfirm() {
    this.dialogVisible = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showProductRecommendedCodeInfoDialog');
    this.$modal.getEventBus().$off('hideProductRecommendedCodeInfoDialog');
  }


}
